import { useEffect } from "react"
import useAuth from "./useAuth"
import useRefreshToken from "./useRefreshToken"
import axios from "axios";



const useAxiosPrivate = () => {
 const refresh=useRefreshToken();
 const {auth}=useAuth();
 const axiosPrivate = axios.create({headers:{'Content-Type':'application/json'},
 withCredentials:true})
 
 useEffect (()=>{
    //creating interceptors 
//request interceptor 
 const requestIntercept= axiosPrivate.interceptors.request.use(
    config => {
        if (!config.headers['Authorization']) {
            config.headers['Authorization']= auth?.accessToken;
            // config.headers['Authorization']=`Bearer ${auth?.accessToken}`;   
        }
        return config;
    } , (error)=> Promise.reject(error)      
    );

    // response interceptor

    const responseIntercept= axiosPrivate.interceptors.response.use(
        response=> response,async(error)=>{
            const prevRequest=error?.config;
            // console.log(error.config)
            // console.log(prevRequest);
            //lines for debugging only 
            if((error?.response?.status === 403 || error?.response?.status === 401) && !prevRequest?.sent){
            // if(error?.response?.status === 401 && !prevRequest?.sent){
                // console.log('access token expierd calling for a new one ');
                prevRequest.sent=true;
                const newAccessToken= await refresh();
                // prevRequest.headers['Authorization']= `Bearer ${newAccessToken}` // in case the statement with only the access token doesn't work
                // console.log(`this is your newaccess token client: ${newAccessToken}`);
                prevRequest.headers['Authorization']= newAccessToken
                return axiosPrivate(prevRequest); // try the previous request to axios now with the new token
            }
            return Promise.reject(error)
        }
    )
    //cleanup function 
    return()=> {
        axiosPrivate.interceptors.request.eject(requestIntercept)
        axiosPrivate.interceptors.response.eject(responseIntercept)
    }
 },[refresh,auth])


  return axiosPrivate;
}

export default useAxiosPrivate